import Component from '../../Component';
import { validate } from 'validate.js';
import { WPAjax } from '../wp-ajax';
import $ from 'jquery';

const GLOBAL_REQUIRED_MESSAGE = '^* This is a required field.';

validate.validators.validateOptionalEmail = (value) => {
	if (!value) {
		return null;
	}

	const validationMessages = validate.single(value, {
		email: true,
	});

	if (validationMessages) {
		return `${validationMessages[0]}`;
	}
	return null;
};

class JoinCampaignModal extends Component<HTMLElement> {
	static selector = '.join-campaign-modal';

	static children = {
		modalWrap: '.modal-wrap',
		form: 'form',
		otherFieldCheckbox: '.trevor-form__field#Other',
		otherFieldText: '[data-name="other"]',
	};

	static validationRules = {
		first_name: {
			presence: {
				message: GLOBAL_REQUIRED_MESSAGE,
				allowEmpty: false,
			},
		},
		last_name: {
			presence: {
				message: GLOBAL_REQUIRED_MESSAGE,
				allowEmpty: false,
			},
		},
		email: {
			validateOptionalEmail: true,
		},
		zip: {
			presence: {
				message: GLOBAL_REQUIRED_MESSAGE,
				allowEmpty: false,
			},
			format: /[0-9]+/,
			length: {
				minimum: 4,
				maximum: 5,
			},
		},
		phone: {
			presence: {
				message: GLOBAL_REQUIRED_MESSAGE,
				allowEmpty: false,
			},
			length: {
				minimum: 0,
				is: 0 as number | undefined, // --> Dynamicall set if phone is provided
				message: 'must be a 10-digit phone number',
			},
		},
		is_adult: {
			presence: {
				message: GLOBAL_REQUIRED_MESSAGE,
				allowEmpty: false,
			},
		},
	};

	afterInit() {
		(
			this.children?.otherFieldCheckbox as HTMLInputElement
		).addEventListener('change', this.onOtherCheckboxChange.bind(this));

		this.bindForm();
	}

	onOtherCheckboxChange() {
		if ((this.children?.otherFieldCheckbox as HTMLInputElement).checked) {
			(this.children?.otherFieldText as HTMLElement).removeAttribute(
				'hidden'
			);
		} else {
			(this.children?.otherFieldText as HTMLElement).setAttribute(
				'hidden',
				'hidden'
			);
		}
	}

	bindForm() {
		(this.children?.form as HTMLFormElement).addEventListener(
			'trevorform-submit',
			this.onSubmit.bind(this) as EventListener
		);
	}

	onSubmit({ detail: { data, component: trevorForm } }: CustomEvent) {
		if (data.phone.length > 0) {
			JoinCampaignModal.validationRules.phone.length.is = 10;
		} else {
			delete JoinCampaignModal.validationRules.phone.length.is;
		}

		// Validate fields
		const validationMessages = validate(
			data,
			JoinCampaignModal.validationRules
		);

		Object.entries(trevorForm.fieldBlocks).forEach(([name]) => {
			trevorForm.setFieldError(
				name,
				validationMessages && validationMessages[name]
					? validationMessages[name][0]
					: false
			);
		});

		if (!validationMessages) {
			trevorForm.setBusy(true);
			this.sendFormData(data)
				.then(() => this.showThankYou())
				.catch(async (err) => {
					const { status } = JSON.parse(err.response);
					window.alert(status); // eslint-disable-line no-alert
				})
				.finally(() => trevorForm.setBusy(false));
		} else {
			this.scrollToTop();
		}
	}

	showThankYou() {
		(this.children?.form as HTMLFormElement & HTMLElement[]).reset();
		this.element.classList.toggle('join-campaign-modal--thank-you');
		this.scrollToTop();
	}

	scrollToTop() {
		$(this.children?.modalWrap as HTMLElement).animate({ scrollTop: 0 });
	}

	async sendFormData(formData: Record<string, any>) {
		await WPAjax({
			action: 'phone2action',
			params: {
				type: 'full',
			},
			data: formData,
		});
	}
}

JoinCampaignModal.init();
